import { lazy } from "react";

export const LoginView = lazy(() => import("./LoginView"));
export const ForgetPwdView = lazy(() => import("./ForgetPwdView"));
export const ResetPwdView = lazy(() => import("./ResetPwdView"));
export const ChangePwdView = lazy(() => import("./ChangePwdView"));
export const SelectWorkspaceView = lazy(() => import("./SelectWorkspaceView"));
export const AcceptInviteView = lazy(() => import("./AcceptInviteView"));
export const AcceptMemberInviteView = lazy(() => import("./AcceptMemberInviteView"));
export const RegisterView = lazy(() => import("./RegisterView"));
export const NotFoundView = lazy(() =>
  import("./NotFoundView").then((m) => ({ default: m.NotFoundView })),
);
